// frontend/src/api/premium.js
import { apiClient } from './index';

const premiumApi = {
  /**
   * Get current user's wallet assets (credits, subscription)
   */
  getStatus: async () => {
    return await apiClient.get('/premium/status');
  },

  /**
   * Buy a credit pack
   * @param {string} type - 'listing' or 'ai_desc'
   * @param {string} packId - '1', '5', '10', etc.
   */
  buyCredits: async (type, packId) => {
    return await apiClient.post('/premium/buy-credits', { type, pack_id: packId });
  },

  /**
   * Subscribe to AI Mechanic
   */
  subscribe: async () => {
    return await apiClient.post('/premium/subscribe', {});
  },

  /**
   * Boost an item
   * @param {string} itemId 
   * @param {string} itemType - 'vehicle' or 'part'
   * @param {string} duration - '1h', '24h', '7d', '30d'
   */
  boostItem: async (itemId, itemType, duration) => {
      return await apiClient.post('/premium/boost', { 
          item_id: itemId, 
          item_type: itemType, 
          duration: duration 
      });
  }
};

export { premiumApi };